import { Capacitor } from "@capacitor/core";
import { FirebaseAuthentication } from "@capacitor-firebase/authentication";
import {
  GoogleAuthProvider,
  signInWithPopup,
  signInWithCredential,
} from "firebase/auth";
import { getAuthInstance } from "../firebase";

/**
 * Login con Google usato da Login.jsx
 * - Web: Firebase Auth con signInWithPopup
 * - iOS/Android (app): plugin @capacitor-firebase/authentication con skipNativeAuth: true
 *   Il plugin mostra il popup Google e restituisce i token.
 *   Noi facciamo signInWithCredential sul JS SDK per autenticare.
 */
export async function signInWithGoogle() {
  const platform = Capacitor.getPlatform();
  console.log(`[GoogleAuth] Avvio login Google su piattaforma: ${platform}`);

  // 🌐 WEB - usa signInWithPopup direttamente
  if (!Capacitor.isNativePlatform()) {
    console.log("[GoogleAuth] Web → signInWithPopup");
    
    const auth = await getAuthInstance();
    const provider = new GoogleAuthProvider();
    provider.addScope("profile");
    provider.addScope("email");
    
    const result = await signInWithPopup(auth, provider);
    console.log("[GoogleAuth] Web login OK:", result.user?.email);
    return { user: result.user };
  }

  // 📱 NATIVE (iOS / Android)
  // Con skipNativeAuth: true, il plugin NON autentica su Firebase.
  // Restituisce solo i token che usiamo per signInWithCredential.
  console.log("[GoogleAuth] Native → skipNativeAuth:true - autenticazione manuale su JS SDK");

  // 1. Ottieni i token dal plugin (popup Google nativo)
  const nativeResult = await FirebaseAuthentication.signInWithGoogle();
  console.log("[GoogleAuth] Native result keys:", Object.keys(nativeResult));

  if (!nativeResult?.credential?.idToken) {
    console.error("[GoogleAuth] Nessun idToken nel risultato nativo!");
    throw new Error("Google Sign-In completed but no idToken received");
  }

  console.log("[GoogleAuth] idToken presente: true");

  // 2. Crea la credenziale per il Web SDK
  const credential = GoogleAuthProvider.credential(
    nativeResult.credential.idToken,
  );

  // 3. Autentica su Firebase JS SDK
  const auth = await getAuthInstance();
  const userCredential = await signInWithCredential(auth, credential);
  
  console.log("[GoogleAuth] JS SDK login OK:", userCredential.user?.email);

  return { user: userCredential.user };
}
